import React from 'react'
import { useSelector } from 'react-redux'
import { useCheckEditCampaignPermission, useCheckSomePermissions, usePermission } from 'hooks/permissions'
import { selectIsInternalUser } from 'state/profile'
import { CAMPAIGN_STATUS_ENUM, selectEditingCampaign, selectEditingCampaignType } from 'state/campaigns'
import { CampaignManagement, CampaignStatusControl } from './enums'

interface CampaignEditorInputFieldContainerProp {
    isEditDeadline?: boolean
    isEditBrief?: boolean
    launchFieldEditable?: boolean
}

const CampaignEditorInputFieldContainer: React.FC<CampaignEditorInputFieldContainerProp> = ({
    children,
    isEditBrief = false,
    isEditDeadline = false,
    launchFieldEditable = false,
}) => {
    const campaign = useSelector(selectEditingCampaign)
    const isInternalUser = useSelector(selectIsInternalUser)
    const isSelfServe = useSelector(selectEditingCampaignType)
    const isPermissionEditable = useCheckEditCampaignPermission(
        (campaign && campaign.status) || undefined,
        isEditBrief, //this is for when updating the create and edit brief permission
        isEditDeadline,
        launchFieldEditable,
    )
    const canPublishOrEditLive =
        useCheckSomePermissions([
            CampaignStatusControl.LaunchCampaign,
            CampaignManagement.LiveCampaignEditBriefs,
            CampaignManagement.LiveCampaignEditDeadlines,
        ]) && campaign?.status === CAMPAIGN_STATUS_ENUM.LIVE
    const canPublishAndEditReview =
        usePermission(CampaignStatusControl.LaunchCampaign) && campaign?.status === CAMPAIGN_STATUS_ENUM.FOR_REVIEW
    const isCampaignEditable = isInternalUser
        ? !isSelfServe || canPublishAndEditReview || canPublishOrEditLive
        : isSelfServe

    const isReadOnly =
        campaign?.status === undefined ? !isPermissionEditable : !isCampaignEditable || !isPermissionEditable

    return (
        <>
            {typeof children === 'function'
                ? children(isReadOnly)
                : React.Children.map(children, (child: any) => {
                      const { isReadOnly: childIsReadyOnly } = child.props
                      return React.cloneElement(child, {
                          isReadOnly: childIsReadyOnly !== undefined ? childIsReadyOnly : isReadOnly,
                      })
                  })}
        </>
    )
}

export default CampaignEditorInputFieldContainer
